import Socket from 'socket.io-client';

const socketUrl = process.env.SOCKET_URL;
const socket = Socket(socketUrl);

export default socket;
